import { css } from '@microsoft/fast-element';
import { scrollbarStyles } from '../../../styles';

export const RfqDetailModalStyles = css`
  ${scrollbarStyles}
  .rfq-modal-content {
    height: calc(100% - 56px);
    overflow: hidden auto;
  }

  .rfq-modal-details {
    font-style: normal;
    font-size: 12px;
    color: rgb(135, 155, 166);
    font-family: Roboto-Medium, 'Roboto Medium', Roboto, sans-serif;
    padding: 8px 16px;
  }

  .rfq-modal-row {
    display: flex;
    padding: 8px;
    gap: 20px;
    border-bottom: 1px solid var(--border-1);
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
  }

  .rfq-modal-row span {
    display: inline-block;
    font-family: Roboto-Medium, 'Roboto Medium', Roboto, sans-serif;
    font-style: normal;
    font-size: 12px;
    color: rgb(204, 204, 204);
    flex: 2 1 0%;
  }

  .rfq-modal-row span:first-of-type {
    text-align: end;
    color: rgb(135, 155, 166);
  }
`;
